import styled from 'styled-components';

import { Anchor, token } from '@zillow/constellation';

export const StyledAnchor = styled(Anchor)`
  font-weight: ${token('fontWeights.bold')};
`;
